/* ============================================================
   Listicle — layout listicle-v4 "ranking report". JS namespace: lpl4.
   Behaviours the export's script and hooks implement (work/02-read.md):
     - masthead "stick to the screen" switch  -> the section's own sticky
       checkbox, pure CSS (reference.md §3e), no script
     - comments shown / reply lines shown      -> blocks + a section checkbox
     - sort and "view more" buttons            -> static labels, as the export
   Nothing needs script, so this file only reserves the namespace. It is kept
   because every layout ships one (reference.md §1) and a later behaviour
   lands here, inside this IIFE, rebinding on shopify:section:load.
   ============================================================ */
(function () {
  'use strict';
  var ns = window.lpl4 = window.lpl4 || {};
  ns.version = '1.0';
})();
